<template>
  <div class="payment-details">
    <!--div class="container-fluid">
      <p class="payment-packages__alert" v-html="$t('change_of_details')"></p>
    </div-->

    <div class="container-fluid">
      <h4>
        <b>{{ $t('details') }}</b>
      </h4>
    </div>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-7">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>{{ $t('beneficiarys_bank') }}</th>
                <th colspan="2">{{ $t('privatbank') }}</th>
                <!-- <th>{{ $t('raiffeisen') }}</th> -->
              </tr>
            </thead>
            <tbody>
              <!-- <tr>
                <td>{{ $t('mfo') }}</td>
                <td>380775</td>
                <td>380805</td>
              </tr>-->
              <tr>
                <td>IBAN</td>
                <td colspan="2">UA03 305299 00000 26008026710283</td>
                <!-- <td>UA96 380805 00000 00026001641198</td> -->
              </tr>
              <tr>
                <td>{{ $t('recipient') }}</td>
                <td colspan="2" style="text-transform: uppercase;">{{ $t('cde_source_2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('edrpou') }}</td>
                <td colspan="2">43642254</td>
              </tr>
              <tr>
                <td>{{ $t('purpose_payment') }}</td>
                <td colspan="2">
                  <span
                    v-t="{
                    path: 'payer_payment',
                    args: {
                      last_name: lastName,
                      first_name: firstName,
                      patronymic: patronymic,
                    },
                  }"
                  ></span>
                  <em>({{ $t('set_class_package') }})</em>
                </td>
              </tr>
            </tbody>
          </table>
          <div style="margin-top: 20px;">
	<a href="https://cdo.org.ua/pdf/Оферта%20(Джерело%20плюс).pdf" title="Договір Оферти Джерело Плюс">
		<img src="/static/front-end/public/assets/images/doc-icon--gray.svg" target="_blank" alt="" width="22px" class="aside-menu__icon">
		<span data-v-102b8074="" class="title">Договір Оферти Джерело Плюс</span>
	</a>
</div>
        		  <div class="change_period" v-if="showSluhach">
				<b>Для продовження дії пакету слухач перейдіть за посиланняям</b>
			  <form action="https://cdo.org.ua/reg/" method="POST" target="_blank">
				<input type="hidden" name="chat_change" value="1">
				<input type="hidden" name="user_id" :value="userId">
				<button class="button button--hollow button--lg"><strong>Змінити період навчання</strong></button>
			  </form>
			</div>
        </div>

        <div class="col-md-5">
          <div class="video">
            <iframe
              src="https://www.youtube.com/embed/5mPVz_2aLFs"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    student: {
      type: Object,
      default: null,
    },
  },
  computed: {
  
    showSluhach() {
		if(this.student.ed_form=="Слухач") return 1;
		return 0;
    },
	userId() {
      return this.student && this.student.id || '1339';
    },

    lastName() {
      return this.student && this.student.last_name || 'Іваненко';
    },
    firstName() {
      return this.student && this.student.first_name || 'Іван';
    },
    patronymic() {
      return this.student && this.student.patronymic || 'Іванович';
    },
    	created() {
		console.log(this.student);
	},

  },
}
</script>

<style lang="scss" scoped>
  .table > thead > tr > th {
    vertical-align: top;
  }
</style>
